import { faDownload, faGlobe, faTag, faNewspaper } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LinkCard = ({ link, onRemove, preview = false }) => {
    const getIcon = () => {
        if (link.isDownload) {
            return faDownload;
        }
        switch (link.type) {
            case 1:
                return faTag;
            case 2:
                return faNewspaper;
            default:
                return faGlobe;
        }
    }
    const getColorClass = () => {
        if (link.isDownload) {
            return "link-download";
        }
        switch (link.type) {
            case 1:
                return "link-product";
            case 2:
                return "link-article";
            default:
                return "link-generic";
        }
    }
    return (
        <div className={`link-card ${preview ? 'is-preview' : ''}`}>
            <FontAwesomeIcon icon={getIcon()} className={`link-icon ${getColorClass()}`} />
            <div className="flex f-col a-start" style={{flexGrow: 1}}>
                <div className="link-title text-snippet snippet-1">{link.text}</div>
                {!preview && <a href={link.isDownload ? process.env.REACT_APP_MEDIA_URL + link.url : link.url} target="_blank" className="link-card-link text-snippet snippet-1">{link.isDownload ? process.env.REACT_APP_MEDIA_URL + link.url : link.url}</a>}
            </div>
            {!preview && (
                <>
                    <div className={`link-type ${getColorClass()}`}>{link.isDownload ? 'Download' : link.type === 1 ? 'Product' : link.type === 2 ? 'Article' : 'Website'}</div>
                    {onRemove ? (
                        <button className="link-remove" onClick={() => onRemove(link)}>
                            {'\u00D7'}
                        </button>
                    ) : null}
                </>
            )}
        </div>
    );
}

export default LinkCard;